export const useClearUnfinishedSummon = () => {
  const clearUnfinishedSummon = async (summonKey: string, onComplete?: () => void) => {
    try {
      const response = await fetch("/auth/team/clear-unfinished-summon", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ summonKey }),
      });

      if (!response.ok) {
        console.error(await response.json());
      } else {
        return await response.json();
      }
    } catch (err) {
      console.error(err);
    } finally {
      onComplete?.();
    }
  };

  return { clearUnfinishedSummon };
};
